export const SystemPaleBgPaletteLight: any = {
    0: '#FFFFFF',
    1: '#E4E5E6',
    2: '#FFDBD8',
    3: '#FDF1CC',
    4: '#D9F3E0',
    5: '#DBEAFF',
}